import { createContext, type ReactNode, useContext } from 'react';

interface ViewContextType {
  roadmapId: number;
  loopId: number;
  viewId: number;
  isPublishedMode: boolean;
}

export const ViewContext = createContext<ViewContextType | undefined>(undefined);

interface ViewProviderProps {
  roadmapId?: number;
  loopId?: number;
  viewId: number;
  isPublishedMode?: boolean;
  children: ReactNode;
}

export function ViewContextProvider({
  viewId,
  roadmapId,
  loopId,
  isPublishedMode = false,
  children,
}: ViewProviderProps) {
  return (
    <ViewContext.Provider
      value={{ viewId, roadmapId: roadmapId || 0, loopId: loopId || 0, isPublishedMode }}
    >
      {children}
    </ViewContext.Provider>
  );
}

export function useViewContext() {
  const context = useContext(ViewContext);
  if (context === undefined) {
    throw new Error('useViewContext must be used within a ViewContextProvider');
  }
  return context;
}
